import Phaser from "phaser";
import { cst } from "../helpers/cst";
import buttonBehaviours from "../helpers/button-behaviours";
import config from "../helpers/config";

export default class Categories3 extends Phaser.Scene {
  constructor() {
    super(cst.scenes.categories3);
  }

  create(data) {
    this.oldScene = data.scene;
    this.categories = [];
    this.category1 = false;
    this.category2 = false;
    this.category3 = false;
    this.total = 0;

    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-main",
    );

    this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        "box-category",
      )
      .setScale(0.8);

    this.btnCategory1 = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 25,
        "btn-category-1",
      )
      .setScale(0.8)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnCategory1, () => {
          if (this.category1 === true) {
            this.category1 = false;
            this.btnCategory1.setFrame(1);
            this.total -= config.category1Length;
            removeItemFromArray(this.categories, "category-1");
          } else {
            this.category1 = true;
            this.btnCategory1.setFrame(0);
            this.total += config.category1Length;
            this.categories.push("category-1");
          }
        });
      })
      .setFrame(1);

    this.btnCategory2 = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 75,
        "btn-category-2",
      )
      .setScale(0.8)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnCategory2, () => {
          if (this.category2 === true) {
            this.category2 = false;
            this.btnCategory2.setFrame(1);
            this.total -= config.category2Length;
            removeItemFromArray(this.categories, "category-2");
          } else {
            this.category2 = true;
            this.btnCategory2.setFrame(0);
            this.total += config.category2Length;
            this.categories.push("category-2");
          }
        });
      })
      .setFrame(1);

    this.btnCategory3 = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 175,
        "btn-category-3",
      )
      .setScale(0.8)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnCategory3, () => {
          if (this.category3 === true) {
            this.category3 = false;
            this.btnCategory3.setFrame(1);
            this.total -= config.category3Length;
            removeItemFromArray(this.categories, "category-3");
          } else {
            this.category3 = true;
            this.btnCategory3.setFrame(0);
            this.total += config.category3Length;
            this.categories.push("category-3");
          }
        });
      })
      .setFrame(1);

    this.btnNext = this.add
      .sprite(
        this.cameras.main.width / 2 + 150,
        this.cameras.main.height / 2 + 410,
        "btn-next",
      )
      .setScale(1.5)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnNext, () => {
          if (this.total < 30) {
            buttonBehaviours.disableInteraction([
              this.btnCategory1,
              this.btnCategory2,
              this.btnCategory3,
              this.btnNext,
            ]);
            const error = this.add.image(
              this.cameras.main.width / 2,
              this.cameras.main.height / 2,
              "error-questions",
            );
            setTimeout(() => {
              buttonBehaviours.enableInteraction([
                this.btnCategory1,
                this.btnCategory2,
                this.btnCategory3,
                this.btnNext,
              ]);
              error.destroy();
            }, 2000);
          } else {
            this.scene.start(cst.scenes.intro, {
              scene: cst.scenes.categories3,
              categories: this.categories,
            });
          }
        });
      });

    this.btnBack = this.add
      .image(
        this.cameras.main.width / 2 - 150,
        this.cameras.main.height / 2 + 410,
        "btn-back",
      )
      .setScale(1.5)
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnBack, () => {
          this.scene.stop();
          this.scene.start(this.oldScene, {
            scene: cst.scenes.categories3,
          });
        });
      });
  }
}

function removeItemFromArray(array, name) {
  const index = array.indexOf(name);
  if (index > -1) {
    array.splice(index, 1);
  }
}
